"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSignatureKeyIvr = void 0;
const types_1 = require("../../../security/authoriser/types");
class MbSignatureKeyIvr {
    constructor(api, data, manager) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
        this.manager = manager;
    }
    async doTransfer() {
        await this.manager.getMethods().raiseN2InIvr(this.data.signatureKeyPositions, this.progressId);
    }
    async doVerify() {
        return {
            type: types_1.ChallengeType.NONE,
            progressId: '',
        };
    }
}
exports.MbSignatureKeyIvr = MbSignatureKeyIvr;
//# sourceMappingURL=signatureKeyIvr.js.map